import { useMemo } from 'react';

import {
  BACKEND_BRAND_VOICE_GENERATION_KEY,
  FRONTEND_BRAND_VOICE_GENERATION_TYPES,
} from 'src/data/brandVoice';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { useCurrentWorkspace, ProjectStore } from 'src/store';

const useProjectState = createStateSelectorHook(ProjectStore, [
  'userBrandVoice',
  'projectBrandVoice',
]);

const isAssociatedBVMatch = (bv, associatedBv, generationTool, type) => {
  return (
    associatedBv.id === bv.brandVoice?.id &&
    bv.generationTool === generationTool &&
    (FRONTEND_BRAND_VOICE_GENERATION_TYPES[bv.key]?.includes(type) ||
      bv.key === BACKEND_BRAND_VOICE_GENERATION_KEY[type])
  );
};

export const useProjectBrandVoices = ({ generationTool, type }) => {
  const currentWorkspace = useCurrentWorkspace();
  const associatedBrandVoices = currentWorkspace?.associatedBrandVoices;
  const { userBrandVoice, projectBrandVoice } = useProjectState();

  return useMemo(() => {
    const selectedProjectBrandVoice = associatedBrandVoices?.find((bv) => {
      return projectBrandVoice?.find((pbv) => isAssociatedBVMatch(pbv, bv, generationTool, type));
    });
    const globalBrandVoice = associatedBrandVoices?.find((bv) => {
      return userBrandVoice?.find((ubv) => isAssociatedBVMatch(ubv, bv, generationTool, type));
    });

    return {
      associatedBrandVoices,
      brandVoice: selectedProjectBrandVoice || globalBrandVoice || associatedBrandVoices?.[0],
    };
  }, [associatedBrandVoices, projectBrandVoice, userBrandVoice, generationTool, type]);
};
